import { css, styled } from 'canoe';

export const WithContentOverflow = styled.div<{
  width?: string;
  height?: string;
}>`
  ${({ width, height }) => css`
    ${width &&
    css`
      width: ${width};
    `}
    ${height &&
    css`
      height: ${height};
    `}
  `}
`;
